var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"jumbotron pt-10 pb-4 pt-md-13 pb-md-6"},[_c('div',{staticClass:"container container-1200"},[_c('div',{staticClass:"row"},[(
                  _vm.privacyPolicyPageData &&
                     _vm.privacyPolicyPageData.content &&
                     _vm.privacyPolicyPageData.content[0]
               )?_c('div',{staticClass:"col-12"},[_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.privacyPolicyPageData.content[0].header))]),_c('div',{staticClass:"pt-6",domProps:{"innerHTML":_vm._s(_vm.markedRender(_vm.privacyPolicyPageData.content[0].longDescription))}})]):_vm._e()])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }